// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizPeriodPicker_cont__3gyI2","label":"BizPeriodPicker_label__HfIYF","picker":"BizPeriodPicker_picker__31Dc4"};